const updates = [
  {
    date: '2026-07-31',
    title: '《唐朝诡事录之西行》全集上线',
    desc: '古装悬疑大剧全集同步上线，杨旭文、杨志刚原班人马回归，探案之旅再启程。',
    icon: 'ri-movie-2-line',
    color: 'bg-primary-100 text-primary-500',
  },
  {
    date: '2026-07-30',
    title: '暑期档专题全新上线',
    desc: '整理暑期热映大片合集，包含动作、科幻、动画等类型，陪你度过炎炎夏日。',
    icon: 'ri-sun-line',
    color: 'bg-accent-100 text-accent-500',
  },
  {
    date: '2026-07-28',
    title: '播放器升级：支持4K超清',
    desc: '平台播放器完成重大升级，部分资源已支持4K超清画质，观影体验再上一个台阶。',
    icon: 'ri-4k-line',
    color: 'bg-secondary-100 text-secondary-500',
  },
  {
    date: '2026-07-25',
    title: '韩剧《泪之女王》热播上线',
    desc: '金秀贤、金智媛主演的年度催泪大戏，全集高清上线，收获观众一致好评。',
    icon: 'ri-heart-line',
    color: 'bg-primary-100 text-primary-500',
  },
  {
    date: '2026-07-22',
    title: '新片《飞驰人生3》高清上线',
    desc: '沈腾、范丞丞主演的赛车喜剧续作，笑料不断，速度与激情的完美结合。',
    icon: 'ri-speed-line',
    color: 'bg-accent-100 text-accent-500',
  },
  {
    date: '2026-07-18',
    title: '纪录片频道资源扩容',
    desc: '新增200+部BBC、Discovery经典纪录片，自然、历史、科技全覆盖，足不出户看世界。',
    icon: 'ri-earth-line',
    color: 'bg-secondary-100 text-secondary-500',
  },
  {
    date: '2026-07-15',
    title: '站点界面全新改版上线',
    desc: '首页布局优化升级，新增分类索引和热度榜单模块，找片更加方便快捷。',
    icon: 'ri-layout-line',
    color: 'bg-primary-100 text-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            平台资源更新与功能上线最新消息
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((update, i) => (
            <div key={i} className="flex gap-4 pb-6 last:pb-0">
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${update.color}`}>
                  <i className={`${update.icon} text-lg`}></i>
                </div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-2"></div>
                )}
              </div>

              <div className="flex-1 pb-2">
                <span className="text-xs text-foreground-400 font-medium">{update.date}</span>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mt-1 mb-1.5">
                  {update.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {update.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}